import React from "react";
import { Button, HeroBanner } from "@relentless/rmds/v1/relentless.esm.js";
import styles from "./NotFoundPage.module.scss";
import { withPublicUrl } from "../lib/publicUrl";

const socialLinks = [
  {
    name: "linkedin",
    href: "https://www.linkedin.com/company/106010588/",
    label: "LinkedIn",
  },
  {
    name: "facebook",
    href: "https://www.facebook.com/therelentlessminds",
    label: "Facebook",
  },
  {
    name: "instagram",
    href: "https://www.instagram.com/therelentlessminds",
    label: "Instagram",
  },
  {
    name: "youtube",
    href: "https://www.youtube.com/@therelentlessminds",
    label: "YouTube",
  },
  {
    name: "tiktok",
    href: "https://www.tiktok.com/@therelentlessminds",
    label: "TikTok",
  },
];

export default function NotFoundPage() {
  const goHome = () => {
    if (typeof window !== "undefined") {
      window.history.pushState({}, "", "/");
      window.dispatchEvent(new Event("popstate"));
    }
  };

  var heroMessage = {
    title: "Seems like you're lost in the mountains...",
    subtitle: "Oops! The page you're looking for doesn't exist.",
    body: (
      <Button
        as="button"
        primary
        size="md"
        icon="home"
        label="Find your way"
        className={styles.primaryCta}
        iconPosition="right"
        onClick={goHome}
      />
    ),
  };

  return (
    <main className={styles.page}>
      <HeroBanner
        className={styles.hero}
        variant="home"
        images={[withPublicUrl("/assets/img/404-mountain-hero.png")]}
        title={heroMessage.title}
        subtitle={heroMessage.subtitle}
        body={heroMessage.body}
        contentAlign="bottom-left"
        showNavigation={false}
        parallax
        layer1={[
          {
            type: "text",
            text: 404,
          },
        ]}
      />
      <nav className={styles.socials} aria-label="Social media links">
        {socialLinks.map((social) => (
          <a
            key={social.name}
            className={styles.socialLink}
            href={social.href}
            target="_blank"
            rel="noreferrer"
            aria-label={social.label}
          >
            <img
              src={withPublicUrl(`/assets/icons/${social.name}.svg`)}
              alt=""
              aria-hidden="true"
            />
          </a>
        ))}
      </nav>
    </main>
  );
}
